import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';
import { PromoContentService } from 'src/app/core/services/promo-content-service/promo-content.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-panther-lake-onboarding',
  templateUrl: './panther-lake-onboarding.component.html',
  styleUrls: ['./panther-lake-onboarding.component.scss'],
})
export class PantherLakeOnboardingComponent implements OnInit, OnDestroy {
  setFontIntelDisplayOne: boolean;
  ptlOnboardingText: any;
  ptlType: string;
  language: string;
  isRTL: boolean;
  isEnglish: boolean;
  ptlArrow: string;
  ptl12xe: boolean = false;
  ptlgaming:boolean = false;
  promoLength: number;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private libraryService: LibraryV2DataService,
    private qrCodeService: QrCodeService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router,
    private promoContentService: PromoContentService
  ) {}

  ngOnInit(): void {
    if(this.qrCodeService.isPantherLakeStd) {
      this.ptlType = GlobalConstants.PANTHER_LAKE;
    } else if(this.qrCodeService.isPantherLake12Xe) {
      this.ptlType = GlobalConstants.PANTHER_LAKE_12XE;
      this.ptl12xe = true;
    }
    else if(this.qrCodeService.isPantherLakeGaming) {
      this.ptlType = GlobalConstants.PANTHER_LAKE_GAMING;
      this.ptlgaming = true;
    }
    this.ptlOnboardingText = this.libraryService.getStaticText('tr_OnboardingText');
    const qrData = this.qrCodeService.getQrData();
    this.language = qrData.Language;
     // AI ASSISTED : addition of link key to ptlOnboardingText.tr_tabs for code optimization
    if (!this.qrCodeService.showVirtualAssistant) {
      this.ptlOnboardingText.tr_tabs = this.ptlOnboardingText?.tr_tabs.filter((item) => item.link !== 'va');
    }

    this.promoContentService.getPromoDataLength.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.promoLength = data;
    });

    this.isRTL = this.language === "ar-sa" || this.language === "he";
    this.isEnglish = this.language === "en-us";
    if(!this.isRTL){
      this.ptlArrow = (this.ptl12xe || this.ptlgaming )? this.ptlOnboardingText.ptl_12xe_right_arrow_icon : this.ptlOnboardingText?.ptl_right_arrow_icon
    } else{
      this.ptlArrow = (this.ptl12xe || this.ptlgaming )? GlobalConstants.LEFT_CHEVERON_WHITE : GlobalConstants.LEFT_CHEVERON_BLACK;     
    }

    this.setFontIntelDisplayOne = this.qrCodeService?.setenusLang();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  routeToPage(tab) {
    const gaParams = this.googleAnalyticsService.scannedParams;

      this.router.navigate([], {
        queryParams: { activeTab: tab.link },
      });
      //AI Suggested: remove the multiple if and change to else if
      if(tab.link == 'specs'){
        let allSpecsText = this.qrCodeService.isChromeBook ? GlobalConstants.VIEW_MORE_TEXT: GlobalConstants.VIEW_ALL_SPECS_TEXT;
        this.googleAnalyticsService.sendGtag(GlobalConstants.VIEW_ALL_SPECS_TEXT, { event_category: allSpecsText, event_label: '', 'view_all_specs': 1, ...gaParams });
      }
      else if(tab.link == 'overview'){
        this.googleAnalyticsService.sendGtag(GlobalConstants.OVERVIEW_TEXT, { event_category: GlobalConstants.OVERVIEW_TEXT, event_label: '', 'overview': 1, ...gaParams });
      }
      else if(tab.link == 'promos')
      {
        this.googleAnalyticsService.sendGtag(GlobalConstants.PROMOS,{ event_category:GlobalConstants.PROMOS, event_label:'', 'promos': 1, ...gaParams });
      }
      else if(tab.link == 'compare'){
        this.googleAnalyticsService.sendGtag( GlobalConstants.COMPARE_DEVICE, { event_category: GlobalConstants.COMPARE_DEVICE, event_label: GlobalConstants.COMPARE_DEVICE, 'compare_device': 1, ...gaParams });
      }
  }
}
